<template>
  <DonateContentSection title="Handmatig" icon="bx:donate-heart">
    <div class="mb-4 flex items-center justify-between rounded border border-neutral-300 bg-neutral-100 text-sm text-neutral-700 dark:border-neutral-600 dark:bg-neutral-800 dark:text-neutral-100">
      <div class="flex grow items-center justify-center bg-neutral-300 px-4 py-2 font-bold text-neutral-700 dark:bg-neutral-600 dark:text-neutral-100">
        IBAN
      </div>
      <div class="flex grow items-center justify-center px-4 py-2">
        NL15 INGB 00 0512 5909
      </div>
    </div>
    <p>t.n.v. Ongehoord (Amsterdam)</p>
  </DonateContentSection>
</template>
